import React from "react";

import styles from "../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function JobShiftEmergencyProcedureTitleBand({ procedure = {} }) {
  return (
    <div className={styles.EmergencyProcedureTitleBandWrapper}>
      <div className={styles.EmergencyProcedureTitleBand}>
        <div className={styles.EmergencyProcedureTitleBandMain}>
          <div className={styles.EmergencyProcedureBandLabel}>RESCUE PROCEDURE</div>
          <div className={styles.EmergencyProcedureBandName}>
            {procedure.title || procedure.procedure_title || ""}
          </div>
        </div>
        <div className={styles.EmergencyProcedureTitleBandChip}>PRO</div>
      </div>
    </div>
  );
}
